import React from 'react';

import { useCreateWorkflowMutation } from '@dashboard/generated/wp/platform';
import usePlatformNavigator from '@dashboard/hooks/navigate/usePlatformNavigator';
import { AddOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';

export default function CreateWorkflowButton() {
  const [create] = useCreateWorkflowMutation();
  const navigator = usePlatformNavigator();

  async function onClick() {
    const { data } = await create({});
    const id = data?.createWorkflow?.id;
    if (id) {
      navigator.showWorkflow(data.createWorkflow.id);
    }
  }

  return (
    <Button size="small" variant="contained" color="primary" onClick={onClick} startIcon={<AddOutlined />}>
      New
    </Button>
  );
}
